import { DeleteCMSTokenEndAction } from "../actions/DeleteCMSToken";
import { AppState } from "../state";

export function deleteCMSToken(state: AppState, action: DeleteCMSTokenEndAction): AppState {
    const { appId, error, tokenId } = action.payload;
    const currentCMSTokens = state.tokens[appId].currentTokens;

    return {
        ...state,
        errorMap: {
            ...state.errorMap,
            [action.type]: error
        },
        tokens: {
            [appId]: {
                ...state.tokens[appId],
                currentTokens: currentCMSTokens.filter(token => token.tokenId !== tokenId)
            }
        }
    };
}
